import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api, track } from "../lib/api";
import { useFlow } from "../context/FlowContext";
import { ArrowLeft, ChevronRight } from "lucide-react";

export default function QuestionSelect() {
  const { categoryId } = useParams();
  const navigate = useNavigate();
  const { update } = useFlow();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/catalog").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  if (!data) return <LoadingStub />;
  const block = data.sub_questions[categoryId];
  if (!block) {
    return (
      <div className="mx-auto max-w-2xl px-5 py-20 text-center">
        <p className="text-muted-foreground">Category not found.</p>
        <button onClick={() => navigate("/")} className="mt-4 rounded-full border px-5 py-2">Go home</button>
      </div>
    );
  }

  const pick = (opt) => {
    track("sub_question_selected", { category: categoryId, sub_question: opt.id, tool_id: opt.tool_id });
    update({ tool: opt.tool_id, subQuestionId: opt.id, question: opt.label });
    navigate(`/ask/${opt.tool_id}`);
  };

  return (
    <div className="mx-auto max-w-2xl px-5 pt-8 md:pt-14">
      <button data-testid="back-btn" onClick={() => navigate("/")} className="mb-6 inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground">
        <ArrowLeft className="h-4 w-4" /> Back
      </button>
      <h1 className="font-display text-3xl font-semibold tracking-tight md:text-4xl" data-testid="subquestion-prompt">
        {block.prompt}
      </h1>
      <div className="mt-8 space-y-3">
        {block.options.map((opt, i) => (
          <button
            key={opt.id}
            data-testid={`subq-${opt.id}`}
            onClick={() => pick(opt)}
            style={{ animationDelay: `${i * 60}ms` }}
            className="card-soft fade-up flex w-full items-center justify-between gap-4 rounded-2xl p-5 text-left btn-lift"
          >
            <span className="flex items-center gap-4">
              <span className="text-2xl">{opt.emoji}</span>
              <span className="font-medium">{opt.label}</span>
            </span>
            <ChevronRight className="h-5 w-5 shrink-0 text-muted-foreground" />
          </button>
        ))}
      </div>
    </div>
  );
}

function LoadingStub() {
  return (
    <div className="mx-auto max-w-2xl px-5 py-20">
      <div className="h-8 w-2/3 rounded-lg bg-muted shimmer" />
      <div className="mt-8 space-y-3">
        {[0, 1, 2, 3].map((i) => <div key={i} className="h-16 rounded-2xl bg-muted shimmer" />)}
      </div>
    </div>
  );
}
